import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiPython,
  DiJava,
  DiMysql,
} from "react-icons/di";
import {
  SiMicrosoftazure,
  SiDjango,
  SiC,
  SiPytorch, SiAmazonaws, SiApachespark, SiTensorflow, SiPowerbi ,
} from "react-icons/si";
import { FaBrain } from "react-icons/fa";
import "./about.css";
import {SiMicrosoftsqlserver } from "react-icons/si";

function Techstack() {
  return (
    <div>
      {/* Programming and Scripting */}
      <h2 className="section-header" style={{ paddingTop: "40px" }}>
        Programming and Scripting
      </h2>
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
        <Col xs={4} md={2} className="tech-icons">
          <DiPython />
          <div className="tech-label">Python</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiC />
          <div className="tech-label">C</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <DiJava />
          <div className="tech-label">Java</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <DiMysql />
          <div className="tech-label">MySQL</div>
        </Col>
      </Row>

      {/* Frameworks and Libraries */}
      <h2 className="section-header">Frameworks and Libraries</h2>
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
        <Col xs={4} md={2} className="tech-icons">
          <SiPytorch />
          <div className="tech-label">PyTorch</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiTensorflow />
          <div className="tech-label">TensorFlow</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiApachespark />
          <div className="tech-label">Spark</div>
        </Col>
	<Col xs={4} md={2} className="tech-icons">
          <SiDjango />
          <div className="tech-label">Django</div>
        </Col>
      </Row>

      {/* AI and Data Science */}
      <h2 className="section-header">AI and Data Science</h2>
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
        <Col xs={4} md={2} className="tech-icons">
          <FaBrain />
          <div className="tech-label">Deep Learning</div>
        </Col>
	<Col xs={4} md={2} className="tech-icons">
	<SiMicrosoftsqlserver/>
          <div className="tech-label">Data Modelling</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiMicrosoftazure />
          <div className="tech-label">Azure ML</div>
        </Col>
	<Col xs={4} md={2} className="tech-icons">
	<SiPowerbi />
          <div className="tech-label">Power BI</div>
        </Col>
	<Col xs={4} md={2} className="tech-icons">
          <SiAmazonaws />
          <div className="tech-label">AWS Core Services</div>
        </Col>
   
    </Row>
    </div>
  );
}

export default Techstack;




